export default "__VITE_ASSET__DBHetpwT__"